import { api, conversationsApi } from "assets/scripts/utilities/api-clients";

export const getTwilioToken = async (identity) => {
  const response = await conversationsApi.post("/twilio/access-token/", {
    identity,
  });

  return response.data.data;
};

export const post = async ({ payload, options }) => {
  const response = await conversationsApi.post(
    `/users/conversationsV2/`,
    payload,
    options,
  );

  return response;
};

export const getContacts = async (options = {}) => {
  const response = await conversationsApi.get("/users", options);

  return response;
};

export const getPOContacts = async (poId) => {
  const response = await api.get(`/kam/purchase-orders/${poId}/contacts`);

  return response;
};

export const getCoreContacts = async (options = {}) => {
  const response = await api.get("/kam/users-and-contacts", options);

  return response;
};

export const getContact = async ({ number } = {}) => {
  const response = await conversationsApi.get(`/users/${number}`);

  return response;
};

export const postContact = async (contact) => {
  const response = await conversationsApi.post("/users", contact);

  return response;
};

export const postParticipant = async ({ payload, options }) => {
  const response = await conversationsApi.post(
    `/users/conversationsV2/participants`,
    payload,
    options,
  );

  return response;
};

export const getTemplates = async (options = {}) => {
  const response = await conversationsApi.get(
    `/wati/getMessageTemplates`,
    options,
  );

  return response;
};

export const getConversationMessages = async ({
  conversationId,
  search,
  offset = 0,
}) => {
  const response = await conversationsApi.get("/users/conversations", {
    params: {
      search,
      conversationId,
      offset,
    },
  });

  return response;
};

export const getUnreadCounts = async () => {
  const response = await conversationsApi.get(
    "/users/conversations/unread/count",
  );

  return response;
};

export const putOneSignalUserId = async ({ oneSignalUserId }) => {
  if (oneSignalUserId) {
    const response = await api.put("/kam/user/onesignal", {
      onesignal_player_id: oneSignalUserId,
    });

    return response;
  }
};

export const postUploadFile = async (file) => {
  const formData = new FormData();

  formData.append("file", file);

  const response = await conversationsApi.post("/files/upload/", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response;
};

export const postCustomContact = async (payload) => {
  const response = await api.post("/kam/contacts", payload);

  return response;
};
